module.exports = __webpack_public_path__ + "static/img/QRCode2.bb079a5b.png";